import { render } from "./MyBase.vue?vue&type=template&id=0c732bc9&scoped=true"
import script from "./MyBase.vue?vue&type=script&lang=js"
export * from "./MyBase.vue?vue&type=script&lang=js"

import "./MyBase.vue?vue&type=style&index=0&id=0c732bc9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c732bc9"]])

export default __exports__